import { render, staticRenderFns } from "./AssignGroupDialog.vue?vue&type=template&id=97587f14"
import script from "./AssignGroupDialog.vue?vue&type=script&lang=ts"
export * from "./AssignGroupDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports